import { Form } from 'antd';
import { FC, memo, useCallback, useState } from 'react';

import { AppMessage } from '@/common/components';
import { FormFieldsErrors } from '../../../../../common/interfaces';
import { extractFormErrors, messageOnError } from '../../../../../common/utils';
import { HostingAccountFormFields, HostingAccountFormInputs } from '../../../hostings.interfaces';
import { useEditHostingAccountsMutation } from '../../../queries';
import { HostingAccountsFormView } from './HostingAccountsFormView';
import { hostingAccountFormValidationSchema } from './validation';

interface Props {
  hostingId: string;
  login: string;
  password: string;
}

export const HostingAccountsEditFormContainer: FC<Props> = memo(({ hostingId, login, password }) => {
  const appMessageApi = AppMessage.useControls();
  const [form] = Form.useForm<HostingAccountFormFields>();
  const [formErrors, setFormErrors] = useState<FormFieldsErrors<typeof HostingAccountFormInputs>>(null);

  const { mutate: editHostingAccountMutation, isLoading: editHostingAccountIsLoading } = useEditHostingAccountsMutation(
    hostingId
  )({
    // onSuccess: (data: HostingAccount) => {},
    onError: (err) => {
      setFormErrors(extractFormErrors<typeof HostingAccountFormInputs>(err));
      messageOnError(err, appMessageApi);
    }
  });

  const initialValues: HostingAccountFormFields = { login, password };

  const handleFinish = useCallback((values: HostingAccountFormFields): void => {
    setFormErrors(null);
    editHostingAccountMutation(values);
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleBack = useCallback(() => {}, []);

  const handleFinishFailed = useCallback((): void => {
    setFormErrors(null);
  }, []);

  return (
    <HostingAccountsFormView
      form={ form }
      formName={ 'hosting-account-edit' }
      formType={ 'edit' }
      initialValues={ initialValues }
      isFormLoading={ editHostingAccountIsLoading }
      validationSchema={ hostingAccountFormValidationSchema }
      formErrors={ formErrors }
      handleBack={ handleBack }
      handleFinish={ handleFinish }
      handleFinishFailed={ handleFinishFailed }
    />
  );
});
